import log from '../services/LogService';

let target:HTMLElement;
let state:string;

// Source - https://stackoverflow.com/a/73896246
// Posted by Tschallacka
// Retrieved 2026-05-07, License - CC BY-SA 4.0

if ('wasDiscarded' in document) {
  // document.getElementById('wasDiscarded').innerText = document.wasDiscarded.toString();
  log.info(`Document was discarded`);
}

function getState() {
  if (document.visibilityState === 'hidden') {
    return 'hidden';
  }
  if (document.hasFocus()) {
    return 'focused';
  }
  return 'not focused';
};

function logStateChange(nextState) {
  var prevState = state;
  if (nextState !== prevState) {
    var timeBadge = new Date().toTimeString().split(' ')[0];
    log.info(`${timeBadge} State changed from ${prevState} to ${nextState}`);
    state = nextState;
  }
};

function onFreeze() {
  logStateChange('frozen');
}

function onPageHide(event) {
  if (event.persisted) {
    // If the event's persisted property is `true` the page is about
    // to enter the page navigation cache, which is also in the frozen state.
    logStateChange('frozen');
  } else {
    // If the event's persisted property is not `true` the page is about to be unloaded.
    logStateChange('terminated');
  }
}

window.addEventListener('pagehide', onPageHide, {capture: true});

export class TabObserver {

  constructor() {
    target = document.getElementById('fpt-modal');
    state = getState();

    window.addEventListener('freeze', onFreeze, {capture: true});
  }

  waitForPageStateChange() {
    log.info(`Waiting for Page status change . . .`);
    return new Promise<void>((fulfill, reject) => {
      const onPageStateChange = () => {
        const newState = getState();
        const returningToTab = newState != state && (state === 'hidden' &&
          (newState === 'not focused' || newState === 'focused') ||
          (state === 'frozen' &&
          (newState === 'not focused' || newState === 'focused')));

        if (returningToTab) {
          ['pageshow', 'focus', 'blur', 'visibilitychange', 'resume'].forEach(function (type) {
            window.removeEventListener(type, onPageStateChange);
          });
          fulfill();
        }

        logStateChange(newState);
      };
      ['pageshow', 'focus', 'blur', 'visibilitychange', 'resume'].forEach(function (type) {
        window.addEventListener(type, onPageStateChange, {capture: true});
      });
      log.info(`Listening to page state change events`);
    });
  }

}
